import React, { useEffect, useState } from "react";
import { CgClose } from "react-icons/cg";
import { useGetEditOfflineInvoice } from "../../hooks/useCrm";
import { formatDate } from "../../utils/formatDate";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";
import { BootstrapModal } from "../BootstrapModal/Modal";
import Button from "../Button/Button";
import { DataPicker } from "../DataPicker/DataPicker";
import { InputField1 } from "../InputField1/InputField1";
const initValue = {
  IdOrderOffline: null,
  PriceAll: null,
  DepositAll: null,
  DateNew: null,
};
export const EditOfflineInvoiceModal = ({ show, handleClose, factor }) => {
  const [button] = useState(false);
  const [form, setForm] = useState(initValue);
  const { mutateAsync: EditFactor } = useGetEditOfflineInvoice();

  useEffect(() => {
    setForm({
      ...form,
      IdOrderOffline: factor?.IdOrderOffline,
      DepositAll: factor?.DepositAll,
      PriceAll: factor?.PriceAll,
    });
  }, [factor]);
  const handleEdit = async (data) => {
    await EditFactor(data).then(() => setForm(initValue));
  };
  return (
    <BootstrapModal
      modaltitle="ویرایش فاکتور"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-lg-6 col-12">
          <InputField1
            label="مبلغ قابل پرداخت"
            onChange={(e) => setForm({ ...form, PriceAll: e.target.value })}
            value={form.PriceAll}
          />
        </div>
        <div className="col-lg-6 col-12">
          <InputField1
            label="مبلغ پرداخت شده"
            onChange={(e) => setForm({ ...form, DepositAll: e.target.value })}
            value={form.DepositAll}
          />
        </div>
        <div className="col-12">
          <DataPicker
            label={`تاریخ جدید (تاریخ فعلی${MiladiToShamsi(
              factor?.created_at
            )})`}
            onChange={(e) => setForm({ ...form, DateNew: formatDate(e) })}
          />
        </div>
        <div className="col-6 mt-3">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleEdit(form);
              handleClose();
            }}
          >
            تایید
          </Button>
        </div>
        <div className="col-6 mt-3">
          <Button
            bgColor="#f1416c"
            color="#fff"
            onclick={() => {
              handleClose();
            }}
          >
            انصراف
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
